import React from "react";

function ProjectTab({ data = {}, onChange }) {
  const handleInput = (e) => {
    const { name, value } = e.target;
    onChange({ ...data, [name]: value });
  };

  const formatDate = (dateStr) => {
    return dateStr ? new Date(dateStr).toISOString().slice(0, 10) : "";
  };

  return (
    <div className="bg-white p-3 rounded-md shadow-md border">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 text-sm">
        
        {/* Project Name */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Project Name</label>
          <input
            name="project_name"
            value={data.project_name || ""}
            onChange={handleInput}
            disabled
            className="border rounded px-2 py-1 cursor-not-allowed"
            placeholder="Enter name"
          />
        </div>

        {/* Address */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Address</label>
          <input
            name="Address"
            value={data.Address || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
          />
        </div>

        {/* Start Date */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Start Date</label>
          <input
            type="date"
            name="start_date"
            value={formatDate(data.start_date)}
            onChange={handleInput}
            className="border rounded px-2 py-1"
          />
        </div>

        {/* End Date */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">End Date</label>
          <input
            type="date"
            name="end_date"
            value={formatDate(data.end_date)}
            onChange={handleInput}
            className="border rounded px-2 py-1"
          />
        </div>

        {/* Status */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Status</label>
          <input
            name="status"
            value={data.status || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="e.g. Planned"
          />
        </div>

        {/* Project Type */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Project Type</label>
          <input
            name="project_type"
            value={data.project_type || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
            placeholder="e.g. Residential"
          />
        </div>

        {/* Concerned Person */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Concerned Person</label>
          <input
            name="Concerned_person"
            value={data.Concerned_person || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
          />
        </div>

        {/* Bank Guarantee Amount */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Bank Guarantee Amount</label>
          <input
            name="Bank_Guarantee_amount"
            value={data.Bank_Guarantee_amount || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
          />
        </div>

        {/* Bank Guarantee Date */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">Bank Guarantee Date</label>
          <input
            type="date"
            name="Bank_Guarantee_date"
            value={formatDate(data.Bank_Guarantee_date)}
            onChange={handleInput}
            className="border rounded px-2 py-1"
          />
        </div>

        {/* EMD Amount */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">EMD Amount</label>
          <input
            name="EMD_amount"
            value={data.EMD_amount || ""}
            onChange={handleInput}
            className="border rounded px-2 py-1"
          />
        </div>

        {/* EMD Date */}
        <div className="flex flex-col">
          <label className="text-gray-600 font-medium mb-1">EMD Date</label>
          <input
            type="date"
            name="EMD_date"
            value={formatDate(data.EMD_date)}
            onChange={handleInput}
            className="border rounded px-2 py-1"
          />
        </div>

        {/* Description */}
        <div className="flex flex-col md:col-span-3">
          <label className="text-gray-600 font-medium mb-1">Description</label>
          <textarea
            name="description"
            value={data.description || ""}
            onChange={handleInput}
            rows={1}
            className="border rounded px-2 py-1 resize-none"
            placeholder="Project description..."
          />
        </div>

      </div>
    </div>
  );
}

export default ProjectTab;
